import { render } from "./navigation-shortcuts.vue?vue&type=template&id=221cd570&scoped=true"
import script from "./navigation-shortcuts.vue?vue&type=script&lang=js"
export * from "./navigation-shortcuts.vue?vue&type=script&lang=js"

import "./navigation-shortcuts.vue?vue&type=style&index=0&id=221cd570&scoped=true&lang=css"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-221cd570"]])

export default __exports__